export default "__VITE_ASSET__DChCcysY__"